// home
import navlogo from "../Assets/Common/navlogo.png";
import bluearrow from "../Assets/Common/bluearrow.png";
import footerbg from "../Assets/Common/footerbg.png";
import herobanner from "../Assets/Home/herobanner.png";
import herobanner2 from "../Assets/Home/herobanner2.png";
import bannercover from "../Assets/Home/bannercover.png";
import aboutimage from "../Assets/Home/aboutimage.png";
import abouticon from "../Assets/Home/abouticon.png";
import servicebg from "../Assets/Home/servicebg.png";
import servicecardimg1 from "../Assets/Home/servicecardimg1.png";
import servicecardimg2 from "../Assets/Home/servicecardimg2.png";
import servicecardimg3 from "../Assets/Home/servicecardimg3.png";
import servicecardimg4 from "../Assets/Home/servicecardimg3.jpg";
import servicecardicon1 from "../Assets/Home/servicecardicon1.png";
import servicecardicon2 from "../Assets/Home/servicecardicon2.png";
import servicecardicon3 from "../Assets/Home/servicecardicon3.png";
import servicecardicon4 from "../Assets/Home/servicecardicon4.png";
import solutioncardimg1 from "../Assets/Home/solutioncardimg1.png";
import solutioncardimg2 from "../Assets/Home/solutioncardimg2.png";
import solutioncardimg3 from "../Assets/Home/solutioncardimg3.png";
import solutionvector from "../Assets/Home/solutionvector.png";
import solutionlayout1 from "../Assets/Home/solutionlayout1.png";
import certificate from "../Assets/Home/certificate.png";
import certificate2 from "../Assets/Home/certificate2.avif";
import certificate3 from "../Assets/Home/certificate3.webp";
import profile from "../Assets/Home/profile.png";
import profile2 from "../Assets/Home/profile2.png";
import profile3 from "../Assets/Home/profile3.png";
import profile4 from "../Assets/Home/profile4.jpg";
import testimonialbg from "../Assets/Home/testimonialbg.png";
import partnerlogo1 from "../Assets/Home/partnerlogo1.png";
import partnerlogo2 from "../Assets/Home/partnerlogo2.png";
import partnerlogo3 from "../Assets/Home/partnerlogo3.png";
import partnerlogo4 from "../Assets/Home/partnerlogo4.png";
import partnerlogo5 from "../Assets/Home/partnerlogo5.png";
import partnerlogo6 from "../Assets/Home/partnerlogo6.png";
import numberbg from "../Assets/Home/numberbg.jpg";
import blogbg from "../Assets/Home/blogbg.png";
import life from "../Assets/Home/life.png";
import blogimg1 from "../Assets/Home/blogimg1.png";
import blogimg2 from "../Assets/Home/blogimg2.png";
import blogimg3 from "../Assets/Home/blogimg3.png";
import blogimg4 from "../Assets/Home/blogimg4.png";
import newscardimg from "../Assets/Home/newscardimg.png";
import lifecardimg1 from "../Assets/Home/lifecardimg1.png";
import lifecardimg2 from "../Assets/Home/lifecardimg2.png";
import lifecardimg3 from "../Assets/Home/lifecardimg3.png";
import logo from "../Assets/Home/logo.png";

// about

import banner from "../Assets/AboutUs/banner.png";
import abouticon1 from "../Assets/AboutUs/abouticon1.png";
import abouticon2 from "../Assets/AboutUs/abouticon2.png";
import abouticon3 from "../Assets/AboutUs/abouticon3.png";
import approachicon1 from "../Assets/AboutUs/approachicon1.png";
import approachicon2 from "../Assets/AboutUs/approachicon2.png";
import approachicon3 from "../Assets/AboutUs/approachicon3.png";
import approachimg from "../Assets/AboutUs/approachimg.png";
import advantageimg from "../Assets/AboutUs/advantageimg.png";
import directorimg from "../Assets/AboutUs/directorimg.png";
import expertimg1 from "../Assets/AboutUs/expertimg1.png";
import expertimg2 from "../Assets/AboutUs/expertimg2.png";
import expertimg3 from "../Assets/AboutUs/expertimg3.png";
import mv1 from "../Assets/AboutUs/mv1.png";
import mv2 from "../Assets/AboutUs/mv2.png";
import mv3 from "../Assets/AboutUs/mv3.png";
import mv4 from "../Assets/AboutUs/mv4.png";
import principlesimg from "../Assets/AboutUs/principlesimg.png";
import vector from "../Assets/AboutUs/vector.png";
import missionicon from "../Assets/AboutUs/missionicon.png";
import visionicon from "../Assets/AboutUs/visionicon.png";

export const assets = {
  // about
  banner,
  missionicon,
  visionicon,
  abouticon1,
  abouticon2,
  abouticon3,
  approachicon1,
  approachicon2,
  approachicon3,
  approachimg,
  advantageimg,
  directorimg,
  expertimg1,
  expertimg2,
  expertimg3,
  mv1,
  mv2,
  mv3,
  mv4,
  principlesimg,
  vector,

  // home
  newscardimg,
  footerbg,
  lifecardimg1,
  lifecardimg2,
  lifecardimg3,
  logo,
  navlogo,
  herobanner,
  herobanner2,
  bannercover,
  aboutimage,
  abouticon,
  bluearrow,
  servicebg,
  servicecardimg1,
  servicecardimg2,
  servicecardimg3,
  servicecardimg4,
  servicecardicon1,
  servicecardicon2,
  servicecardicon3,
  servicecardicon4,
  solutioncardimg1,
  solutioncardimg2,
  solutioncardimg3,
  solutionvector,
  solutionlayout1,
  certificate,
  certificate2,
  certificate3,
  profile,
  profile2,
  profile3,
  profile4,
  testimonialbg,
  partnerlogo1,
  partnerlogo2,
  partnerlogo3,
  partnerlogo4,
  partnerlogo5,
  partnerlogo6,
  numberbg,
  blogbg,
  life,
  blogimg1,
  blogimg2,
  blogimg3,
  blogimg4,
};
